/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddSubscriptionInput = {|
  subName: string,
  parent: string,
  source: string,
|};
export type AddSmallScreenSubMutationVariables = {|
  input: AddSubscriptionInput
|};
export type AddSmallScreenSubMutationResponse = {|
  +addSubscription: ?{|
    +subEdge: ?{|
      +cursor: string,
      +node: ?{|
        +id: string,
        +name: ?string,
        +source: ?{|
          +id: string,
          +name: ?string,
          +image_url: ?string,
          +source_icon: ?string,
        |},
        +parent: ?{|
          +id: string
        |},
      |},
    |}
  |}
|};
export type AddSmallScreenSubMutation = {|
  variables: AddSmallScreenSubMutationVariables,
  response: AddSmallScreenSubMutationResponse,
|};
*/


/*
mutation AddSmallScreenSubMutation(
  $input: AddSubscriptionInput!
) {
  addSubscription(input: $input) {
    subEdge {
      cursor
      node {
        id
        name
        source {
          id
          name
          image_url
          source_icon
        }
        parent {
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddSubscriptionPayload",
    "kind": "LinkedField",
    "name": "addSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SubscriptionEdge",
        "kind": "LinkedField",
        "name": "subEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SubscriptionNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SourceNode",
                "kind": "LinkedField",
                "name": "source",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "image_url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "source_icon",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SubscriptionNode",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddSmallScreenSubMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddSmallScreenSubMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "17b93a574b6ba2ccbf3785855edcc95c",
    "id": null,
    "metadata": {},
    "name": "AddSmallScreenSubMutation",
    "operationKind": "mutation",
    "text": "mutation AddSmallScreenSubMutation(\n  $input: AddSubscriptionInput!\n) {\n  addSubscription(input: $input) {\n    subEdge {\n      cursor\n      node {\n        id\n        name\n        source {\n          id\n          name\n          image_url\n          source_icon\n        }\n        parent {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '43acf0a13d0e487b03c4916c039883d0';

module.exports = node;
